import { render, staticRenderFns } from "./DashBoardSideMenu.vue?vue&type=template&id=62b736ca&scoped=true&"
import script from "./DashBoardSideMenu.vue?vue&type=script&lang=js&"
export * from "./DashBoardSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardSideMenu.vue?vue&type=style&index=0&id=62b736ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b736ca",
  null
  
)

export default component.exports